import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useCallback } from 'react';
import { Icon } from 'panamera-react-ui';
import { FormattedMessage as Translation } from 'react-intl';
import withConfig from "../../../ComponentDependency/withConfig";
import { InspectionTypeMap, INSPECTION_TYPE } from "../../../Types/widgets/BookingConfirmedV2";
import { CALLBACK_ASSISTED_SI_REDIRECTION_CTA, CALLBACK_ASSISTED_SI_HOME, ASSISTED_INSPECTION_SUCCESSFUL, ASSISTED_INSPECTION_TAP_CONTINUE, SELF_INSPECT } from "../../../Constants/templateName";
import UserSession from "../../../Utils/UserSession";
var css = {
  "bcWidget": "oalp-3cmKj",
  "widgetCont": "oalp-3bSC8",
  "bgImage": "oalp-K7Uxf",
  "carDetails": "oalp-3UdKR",
  "carTitle": "oalp-RG8Sh",
  "carSubtitle": "oalp-3Ugde",
  "mileage": "oalp-3gegu",
  "headerDetails": "oalp-1BoSn",
  "crossIcon": "oalp-3eA6C",
  "image": "oalp-7ohUn",
  "textsec": "oalp-3-dFw",
  "dateTimeWrapper": "oalp-2TPsd",
  "dateTimeTitle": "oalp-VJ--3",
  "date": "oalp-2vuGm",
  "time": "oalp-2h9n5",
  "timeClock": "oalp-3HtPs",
  "timeLeft": "oalp-1uMrh",
  "dashedBorder": "oalp-2DheE",
  "phoneTitle": "oalp-1MOqk",
  "dateWrapper": "oalp-2hnfS",
  "phoneNo": "oalp-1UlZz",
  "buttonWrapper": "oalp-1e7od",
  "button": "oalp-3QFNM",
  "instructionsWrapper": "oalp-57AEJ",
  "instructionsTitle": "oalp-2vgcO",
  "instructionsList": "oalp-1sztm",
  "body1": "oalp-R8XH2",
  "footnote": "oalp-3fN2P",
  "flex": "oalp-1--72"
};
import { populateStringTemplate } from "../../../Utils/TextHelper";
import CTA from "../../../Components/CTA/CTA";
import { getFormatedTimeSlot, getDaysLeft } from "./../renderHelpers";
import ImageWrapper from "../../../Components/ImageWrapper/ImageWrapper";
import { EVALUATION_STATES, EVALUATION_STATES_TRACKING, FLOW_TYPES, FIELD_NAMES } from "../../../Constants/evaluation";
import { trackingHelper } from "../../../Helpers/trackingHelper";
import { TRACKING_EVENTS } from "../../../Constants/trackingEvents";
import DependencyManager from "../../../DependencyManager";
import { isEmpty } from "../../../Helpers/bundle";
var getDaysLeftComponent = function getDaysLeftComponent(daysLeft) {
  var values = {
    daysLeft: daysLeft
  };
  if (daysLeft > 1) {
    return /*#__PURE__*/React.createElement(Translation, {
      id: "daysLeft",
      values: values
    });
  }
  return /*#__PURE__*/React.createElement(Translation, {
    id: "dayLeft",
    values: values
  });
};
export var BookingConfirmedV2 = function BookingConfirmedV2(_ref) {
  var data = _ref.data,
    _ref$metadata = _ref.metadata,
    style = _ref$metadata.style,
    showCrossIcon = _ref$metadata.showCrossIcon,
    name = _ref.name,
    track = _ref.track,
    locationId = _ref.locationId,
    handleIconClick = _ref.handleIconClick,
    handleCallbackClick = _ref.handleCallbackClick,
    origin = _ref.origin,
    userIsLogged = _ref.userIsLogged,
    config = _ref.config,
    landingURLSearch = _ref.landingURLSearch,
    params = _ref.params,
    disclaimer = _ref.disclaimer;
  var _a;
  var image = data.image,
    title = data.title,
    subTitle = data.subTitle,
    _data$cta = data.cta,
    _data$cta$buttons = _data$cta.buttons,
    buttons = _data$cta$buttons === void 0 ? [] : _data$cta$buttons,
    buttonWrapperStyles = _data$cta.style,
    backgroundImage = data.backgroundImage,
    assistedSiInstructions = data.assistedSiInstructions;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    appointmentDetails = _useState2[0],
    setAppointmentDetails = _useState2[1];
  var isMxCl = !!config.get('olxAutos', 'isMXCL');
  var siteCode = config.get('siteCode');
  var isL2PTracker = !!config.get('isL2PTracker');
  var isglobalTimeRequired = config.get('isLocalDateRequired') || ((_a = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.config) === null || _a === void 0 ? void 0 : _a.is_24_format_enabled);
  var PanameraConstants = DependencyManager.getDependency('constants');
  var IS_DEKSTOP = PanameraConstants.platform === 'desktop';
  useEffect(function () {
    if (buttons === null || buttons === void 0 ? void 0 : buttons.length) {
      var _name = buttons[0].name;
      if (_name === CALLBACK_ASSISTED_SI_REDIRECTION_CTA || _name === CALLBACK_ASSISTED_SI_HOME) {
        var eventDetails = {
          eventName: ASSISTED_INSPECTION_SUCCESSFUL,
          select_from: EVALUATION_STATES_TRACKING.AI_COMPLETED
        };
        trackingHelper(Object.assign({
          track: track,
          locationId: locationId,
          origin: origin,
          landingURLSearch: landingURLSearch,
          params: params,
          config: config.get()
        }, eventDetails));
      }
    }
  }, [buttons, config, landingURLSearch, locationId, origin, params, track]);
  useEffect(function () {
    var details = UserSession.getAppointmentDetails() || {};
    if (!isEmpty(assistedSiInstructions)) {
      var valuationDetails = UserSession.getUserEvaluationFormValues();
      if (valuationDetails != null) {
        details = {
          vehicle: ['make', 'model', 'year', 'mileage', 'variant'].reduce(function (acc, item) {
            acc[item] = valuationDetails["".concat(item, "-displayValue")];
            return acc;
          }, {})
        };
      }
    }
    setAppointmentDetails(details);
  }, [assistedSiInstructions]);
  var _appointmentDetails$v = appointmentDetails.vehicle,
    _appointmentDetails$v2 = _appointmentDetails$v === void 0 ? {} : _appointmentDetails$v,
    _appointmentDetails$v3 = _appointmentDetails$v2.make,
    make = _appointmentDetails$v3 === void 0 ? '' : _appointmentDetails$v3,
    _appointmentDetails$v4 = _appointmentDetails$v2.model,
    model = _appointmentDetails$v4 === void 0 ? '' : _appointmentDetails$v4,
    _appointmentDetails$v5 = _appointmentDetails$v2.year,
    year = _appointmentDetails$v5 === void 0 ? '' : _appointmentDetails$v5,
    _appointmentDetails$v6 = _appointmentDetails$v2.mileage,
    mileage = _appointmentDetails$v6 === void 0 ? '' : _appointmentDetails$v6,
    _appointmentDetails$v7 = _appointmentDetails$v2.variant,
    variant = _appointmentDetails$v7 === void 0 ? '' : _appointmentDetails$v7,
    slotDetails = appointmentDetails.slotDetails,
    bookingId = appointmentDetails.bookingId,
    mobile = appointmentDetails.mobile,
    _appointmentDetails$i = appointmentDetails.inspectionType,
    inspectionType = _appointmentDetails$i === void 0 ? '' : _appointmentDetails$i;
  var onTrack = useCallback(function (name) {
    var eventDetails = {
      eventName: TRACKING_EVENTS.BOOK_APPOINTMENT_TAP_SEE_DETAILS,
      select_from: EVALUATION_STATES_TRACKING.APPOINTMENT_CREATED,
      field_name: ''
    };
    if (name === CALLBACK_ASSISTED_SI_REDIRECTION_CTA || name === CALLBACK_ASSISTED_SI_HOME || name === SELF_INSPECT) {
      eventDetails.eventName = ASSISTED_INSPECTION_TAP_CONTINUE;
      eventDetails.select_from = EVALUATION_STATES_TRACKING.AI_COMPLETED;
      eventDetails.field_name = name === SELF_INSPECT ? FIELD_NAMES.SELF_INSPECT : FIELD_NAMES.GO_TO_HOME;
    }
    trackingHelper(Object.assign({
      track: track,
      locationId: locationId,
      origin: origin,
      landingURLSearch: landingURLSearch,
      params: params,
      config: config.get()
    }, eventDetails));
  }, [track, locationId, origin, landingURLSearch, params, config]);
  var _ref2 = slotDetails ? getFormatedTimeSlot(slotDetails, siteCode, isglobalTimeRequired) : {},
    _ref2$date = _ref2.date,
    date = _ref2$date === void 0 ? null : _ref2$date,
    _ref2$time = _ref2.time,
    time = _ref2$time === void 0 ? null : _ref2$time;
  var daysLeft = getDaysLeft(slotDetails);
  function buttonJSX() {
    return buttons.map(function (button, idx) {
      button = Object.assign(Object.assign({}, button), {
        invert: false,
        action: !IS_DEKSTOP && isL2PTracker ? '/appointment/lead_tracker' : populateStringTemplate(button.action, {
          bookingId: bookingId,
          inspectionType: inspectionType === INSPECTION_TYPE.HOME ? InspectionTypeMap.INSPECTIONHOME : InspectionTypeMap.INSPECTION
        })
      });
      return /*#__PURE__*/React.createElement(CTA, {
        "data-aut-id": "see_details_".concat(idx),
        key: "widget_".concat(name, "_cta_").concat(idx),
        button: button,
        customClass: css.button,
        widgetKey: name,
        track: track,
        onTrack: onTrack,
        locationId: locationId,
        handleCallbackClick: handleCallbackClick,
        select_from: EVALUATION_STATES_TRACKING.APPOINTMENT_CREATED,
        flow_type: FLOW_TYPES.NO_DRAFT
      });
    });
  }
  var crossIconClick = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (handleIconClick) {
      handleIconClick(EVALUATION_STATES.APPOINTMENT_CREATED);
    }
  }, [handleIconClick]);
  var detailsSectionJSX = function detailsSectionJSX() {
    if (!isEmpty(assistedSiInstructions)) {
      var _assistedSiInstructio = assistedSiInstructions.title,
        sectionTitle = _assistedSiInstructio.text,
        titleStyle = _assistedSiInstructio.style,
        _assistedSiInstructio2 = assistedSiInstructions.instructions,
        list = _assistedSiInstructio2.list,
        instructionsStyle = _assistedSiInstructio2.style;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: css.instructionsWrapper,
        "data-aut-id": "instructions-wrapper"
      }, /*#__PURE__*/React.createElement("h3", {
        style: titleStyle,
        className: css.instructionsTitle
      }, sectionTitle), /*#__PURE__*/React.createElement("ol", {
        style: instructionsStyle,
        className: css.instructionsList
      }, list.map(function (instruction, idx) {
        return /*#__PURE__*/React.createElement("li", {
          key: idx
        }, instruction);
      }))), /*#__PURE__*/React.createElement("div", {
        style: buttonWrapperStyles
      }, buttonJSX()));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: css.dateTimeWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: css.dateTimeTitle
    }, /*#__PURE__*/React.createElement(Translation, {
      id: "dateAndTime"
    })), /*#__PURE__*/React.createElement("div", {
      className: css.date
    }, /*#__PURE__*/React.createElement("span", {
      className: css.iconWrapper,
      role: "listbox",
      tabIndex: 0,
      "data-aut-id": "meeting"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "meeting",
      size: 20
    })), /*#__PURE__*/React.createElement("span", {
      className: css.dateWrapper
    }, date)), /*#__PURE__*/React.createElement("div", {
      className: css.time
    }, /*#__PURE__*/React.createElement("div", {
      className: css.timeClock
    }, /*#__PURE__*/React.createElement("span", {
      className: css.iconWrapper,
      role: "listbox",
      tabIndex: 0,
      "data-aut-id": "clock"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "clock",
      size: 20
    })), /*#__PURE__*/React.createElement("span", {
      className: css.timeLeft
    }, time)), daysLeft > 0 && /*#__PURE__*/React.createElement("div", {
      className: css.daysLeft
    }, getDaysLeftComponent(daysLeft), " ")), /*#__PURE__*/React.createElement("div", {
      className: css.dashedBorder
    }), mobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: css.phoneTitle
    }, /*#__PURE__*/React.createElement(Translation, {
      id: "contactText"
    })), /*#__PURE__*/React.createElement("div", {
      className: css.phoneNo
    }, mobile))), /*#__PURE__*/React.createElement("div", {
      style: buttonWrapperStyles,
      className: css.buttonWrapper
    }, (isMxCl || userIsLogged) && buttonJSX()));
  };
  var widgetContainerClass = css.widgetCont;
  if (!isEmpty(assistedSiInstructions) && !IS_DEKSTOP) {
    widgetContainerClass = '';
  }
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: css.bcWidget
  }, backgroundImage && /*#__PURE__*/React.createElement(ImageWrapper, {
    image: backgroundImage,
    className: css.bgImage
  }), /*#__PURE__*/React.createElement("div", {
    className: widgetContainerClass
  }, /*#__PURE__*/React.createElement("div", {
    className: css.headerDetails
  }, showCrossIcon && /*#__PURE__*/React.createElement("span", {
    className: css.crossIcon,
    onClick: crossIconClick,
    "data-aut-id": "cross_icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "cross",
    color: "blackText",
    size: 20
  })), /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image,
    className: css.image
  }), /*#__PURE__*/React.createElement("div", {
    className: css.textsec,
    "data-aut-id": "ap_confirmed_hp"
  }, title && /*#__PURE__*/React.createElement("p", {
    style: title.style
  }, title.text), subTitle && /*#__PURE__*/React.createElement("p", {
    style: subTitle.style
  }, subTitle.text))), /*#__PURE__*/React.createElement("div", {
    className: css.carDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: css.carTitle
  }, make, " ", model, ", ", year), /*#__PURE__*/React.createElement("div", {
    className: css.carSubtitle
  }, variant), mileage && /*#__PURE__*/React.createElement("div", {
    className: css.mileage
  }, mileage, " ", /*#__PURE__*/React.createElement(Translation, {
    id: "mileage"
  }))), detailsSectionJSX()));
};
export default withConfig(BookingConfirmedV2);